<template lang="html">
	<!--el-select v-model="lang" :placeholder="$t('language')" style="width:40px;margin-left:15px;">
		<el-option
			v-for="item in options"
			:key="item.value"
			:label="item.label"
			:value="item.value">
		</el-option>
	</el-select-->
	<el-dropdown @command="handleCommand" style="width:40px;padding-left:10px;display:inline;box-sizing:border-box;" :hide-on-click="true" trigger="hover">
		<span class="el-dropdown-link">
		{{ lang.short }}<i class="el-icon-arrow-down el-icon--right"></i>
		</span>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item v-for="item in options" :command="item">{{ item.label }}</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>

</template>
<script>
export default {
	name: "LanguageSelect",
	props: {
		onChanged: Function,
		initialLanguage: String
	},
	data: () => ({
		lang: {
			value: "en",
			label: "English",
			short: "En"
		},
		options: [{
			value: "en",
			label: "English",
			short: "En"
		}, {
			value: "ru",
			label: "Русский",
			short: "Ру"
		}]
	}),
	created: function () {
		console.log("inilang", this.initialLanguage);
		for (let item of this.options) {
			if (item.value === this.initialLanguage) {
				this.lang = item;
				break;
			}
		}
	},
	methods: {
		handleCommand: function (item) {
			this.lang = item;
			this.onChanged(item.value);
		}
	}
}
</script>